import { Platform, View } from 'react-native'

import { AnimatePresence } from 'moti'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { FullWindowOverlay } from 'react-native-screens'

import { SAFE_AREA_TOP, ToastContent } from './ToastContent'
import type { ToastProps } from './types'

const OverLayView = Platform.OS === 'ios' ? FullWindowOverlay : View

export const ToastContainer = ({
  show,
  render,
  heading,
  description,
  intent,
  hide,
  action,
  leftIcon,
}: ToastProps) => {
  const { top } = useSafeAreaInsets()
  return (
    <AnimatePresence>
      {show && (
        <OverLayView
          style={{
            position: 'absolute',
            width: '100%',
            top: top === 0 ? SAFE_AREA_TOP : top,
          }}
        >
          <ToastContent
            heading={heading}
            intent={intent}
            description={description}
            hide={hide}
            render={render}
            action={action}
            leftIcon={leftIcon}
          />
        </OverLayView>
      )}
    </AnimatePresence>
  )
}
